<div class="card">
  <!-- Header Section -->
  <div class="field md:col-12 col-12">
    <div class="district-border">
      <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap: wrap">
        <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">
          {{ 'Outlet Wise Total Application Count and Total Area Applied Graph' }}
        </label>
      </div>
    </div>
  </div>

  <!-- Charts Container -->
  <div class="charts-container" style="display: flex; flex-wrap: wrap; gap: 20px;">
    <!-- Count of Applications Chart -->
    <!-- <div style="flex: 1 1 45%; position: relative; height:400px;"> -->
    <div class="field md:col-12 col-12">
      <p-chart type="bar" [data]="countAppsChartData" [options]="countAppsChartOptions"></p-chart>
    </div>

    <!-- Total Applied Area Chart -->
    <!-- <div style="flex: 1 1 45%; position: relative; height:400px;"> -->
    <div class="field md:col-12 col-12">
      <p-chart type="bar" [data]="totalAreaChartData" [options]="totalAreaChartOptions"></p-chart>
    </div>
  </div>
</div>

<!-- EPC Table -->
<div *ngIf="epcTableData.length > 0" class="card dashboardTable" style="margin: 5px;">
  <p-table [value]="epcTableData" [rows]="10" [paginator]="true" responsiveLayout="scroll" [rowHover]="true"
    [showCurrentPageReport]="true">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'S_NO' | translate }}</th>
        <!-- <th>{{ 'VENDOR_NAME' | translate }}</th> -->
        <th>{{ 'APP_ID' | translate }}</th>
        <th>{{ 'NAME' | translate }}</th>
        <th>{{ 'FATHER_NAME' | translate }}</th>
        <th>{{ 'MOBILE_NO' | translate }}</th>
        <th>{{ 'MFMB_NO' | translate }}</th>
        <th>{{ 'PROGRAM_NAME' | translate }}</th>
        <th>{{ 'TOTAL_AREA' | translate }}</th>
        <th>{{ 'FARMER_CATEGORY' | translate }}</th>
        <th>{{ 'VILLAGE' | translate }}</th>
        <th>{{ 'SURVEY_STATUS' | translate }}</th>
        <th>{{ 'APPROVAL_STATUS' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
      <tr>
        <td>{{ rowIndex + 1 }}</td>
        <td>{{ product.APP_ID }}</td>
        <td>{{ product.Name }}</td>
        <td>{{ product.Father_name }}</td>
        <td>{{ product.Mobile }}</td>
        <td>{{ product.MFMBNo }}</td>
        <td>{{ product.ProposedSystem }}</td>
        <td>{{ product.TotalArea }}</td>
        <td>{{ product.FarmerCategory1 }}</td>
        <td>{{ product.Village }}</td>
        <td>
          {{ product.SurveyStatus === 1 ? 'Approved' : 'Pending' }}
        </td>
        <td>
          {{ product.ApprovalStatus === 1 ? 'Approved' : 'Pending' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>